export default [
  {
    //img: 'img/theme/bootstrap.jpg',
    title: 'VLAC CONSULTING',
    budget: 'BGYE-2021-001',
    type: 'AUDITORIA - INMUEBLE',
    fullname: 'OMAR CARTAGENA',
    city: 'GUAYAQUIL',
    vrealizacion: '$264573.68 USD',
    vmercado: '$264573.68 USD',
    locationmap: 'Sanborondon',
    oaccount: 'Sara Heredia',
    vfactura: '$2302,10 USD',
    link: 'https://umediadigital-my.sharepoint.com/:b:/g/personal/joselynv_u-mediadigital_com/ES3R8Ind7NlKv9IRzd6llNQBdzoCkAd1vgPytTHBJ0VT2w?e=iL7UxH',

    status: 'completed',
    statusType: 'success',
    completion: 60
  },
  {
    //img: 'img/theme/bootstrap.jpg',
    title: 'VLAC CONSULTING',
    budget: 'BGYE-2021-002',
    type: 'AUDITORIA - INMUEBLE',
    fullname: 'PABLO LARGO',
    city: 'CUENCA',
    vrealizacion: '$67896.51 USD',
    vmercado: '$67896.51 USD',
    locationmap: 'San Sebastian',
    oaccount: 'Deysi Ocampo',
    vfactura: '$1233,10 USD',
    link: 'https://stackoverflow.com/questions/22496975/functionevent-vs-function-in-jquery',

    status: 'completed',
    statusType: 'success',
    completion: 100
  },
  {
    //img: 'img/theme/bootstrap.jpg',
    title: 'VLAC CONSULTING',
    budget: 'BGYE-2021-003',
    type: 'AUDITORIA - INMUEBLE',
    fullname: 'TENERIA SAN JOSE',
    city: 'AMBATO',
    vrealizacion: '$23432 USD',
    vmercado: '$23432 USD',
    locationmap: 'Ambato',
    oaccount: 'Carolina Aldas',
    vfactura: '$2302,10 USD',
    link: 'https://umediadigital-my.sharepoint.com/:b:/g/personal/joselynv_u-mediadigital_com/ES3R8Ind7NlKv9IRzd6llNQBdzoCkAd1vgPytTHBJ0VT2w?e=iL7UxH',

    status: 'completed',
    statusType: 'success',
    completion: 100
  },
  {
    //img: 'img/theme/bootstrap.jpg',
    title: 'VLAC CONSULTING',
    budget: 'BGYE-2021-004',
    type: 'AUDITORIA - INMUEBLE',
    fullname: 'GMAX',
    city: 'QUITO',
    vrealizacion: '$275932.10 USD',
    vmercado: '$275932.10 USD',
    locationmap: 'Urb.la Colina',
    oaccount: 'Dayana Pantoja',
    vfactura: '$2302,10 USD',
    link: 'https://umediadigital-my.sharepoint.com/:b:/g/personal/joselynv_u-mediadigital_com/ES3R8Ind7NlKv9IRzd6llNQBdzoCkAd1vgPytTHBJ0VT2w?e=iL7UxH',

    status: 'completed',
    statusType: 'success',
    completion: 60
  },
  {
    //img: 'img/theme/bootstrap.jpg',
    title: 'TINSA',
    budget: 'BGYE-2021-005',
    type: 'MAQUINARIA',
    fullname: 'ADELCA',
    city: 'QUITO',
    vrealizacion: '$0 USD',
    vmercado: '$0 USD',
    locationmap: 'El Batan',
    oaccount: 'Andrea Hidalgo',
    vfactura: '$2302,10 USD',
    link: 'https://umediadigital-my.sharepoint.com/:b:/g/personal/joselynv_u-mediadigital_com/ES3R8Ind7NlKv9IRzd6llNQBdzoCkAd1vgPytTHBJ0VT2w?e=iL7UxH',

    status: 'pending',
    statusType: 'warning',
    completion: 60
  },
  {
    //img: 'img/theme/bootstrap.jpg',
    title: 'INMOMERCEDES',
    budget: 'BGYE-2021-006',
    type: 'PRENDA MATERIA PRIMA',
    fullname: 'FRANKLIN CUMBA',
    city: 'GUAYAQUIL',
    vrealizacion: '$0 USD',
    vmercado: '$0 USD',
    locationmap: '',
    oaccount: 'Raquel Chavez',
    vfactura: '$2302,10 USD',
    link: 'https://umediadigital-my.sharepoint.com/:b:/g/personal/joselynv_u-mediadigital_com/ES3R8Ind7NlKv9IRzd6llNQBdzoCkAd1vgPytTHBJ0VT2w?e=iL7UxH',

    status: 'pending',
    statusType: 'warning',
    completion: 60
  },
  {
    //img: 'img/theme/bootstrap.jpg',
    title: 'ACURIO Y ASOCIADOS',
    budget: 'BGYE-2021-007',
    type: 'MAQUINARIA',
    fullname: 'TERESA ANDAGOYA',
    city: 'AMBATO',
    vrealizacion: '$0 USD',
    vmercado: '$0 USD',
    locationmap: '',
    oaccount: 'Belén Castro',
    vfactura: '$2302,10 USD',
    link: 'https://umediadigital-my.sharepoint.com/:b:/g/personal/joselynv_u-mediadigital_com/ES3R8Ind7NlKv9IRzd6llNQBdzoCkAd1vgPytTHBJ0VT2w?e=iL7UxH',

    status: 'pending',
    statusType: 'warning',
    completion: 60
  },
  {
    //img: 'img/theme/bootstrap.jpg',
    title: 'PERITO X',
    budget: 'BGYE-2021-XXX',
    type: 'TIPO XXX',
    fullname: 'CLIENTE NOMBRE',
    city: 'CIUDAD',
    vrealizacion: '$0 USD',
    vmercado: '$0 USD',
    locationmap: '',
    oaccount: 'Asignado',
    vfactura: '$2302,10 USD',
    link: 'https://umediadigital-my.sharepoint.com/:b:/g/personal/joselynv_u-mediadigital_com/ES3R8Ind7NlKv9IRzd6llNQBdzoCkAd1vgPytTHBJ0VT2w?e=iL7UxH',

    status: 'pending',
    statusType: 'warning',
    completion: 60
  },
  {
    //img: 'img/theme/bootstrap.jpg',
    title: 'PERITO X',
    budget: 'BGYE-2021-XXX',
    type: 'TIPO XXX',
    fullname: 'CLIENTE NOMBRE',
    city: 'CIUDAD',
    vrealizacion: '$0 USD',
    vmercado: '$0 USD',
    locationmap: '',
    oaccount: 'Asignado',
    vfactura: '$2302,10 USD',
    link: 'https://umediadigital-my.sharepoint.com/:b:/g/personal/joselynv_u-mediadigital_com/ES3R8Ind7NlKv9IRzd6llNQBdzoCkAd1vgPytTHBJ0VT2w?e=iL7UxH',

    status: 'pending',
    statusType: 'warning',
    completion: 60
  },
  {
    //img: 'img/theme/bootstrap.jpg',
    title: 'PERITO X',
    budget: 'BGYE-2021-XXX',
    type: 'TIPO XXX',
    fullname: 'CLIENTE NOMBRE',
    city: 'CIUDAD',
    vrealizacion: '$0 USD',
    vmercado: '$0 USD',
    locationmap: '',
    oaccount: 'Asignado',
    vfactura: '$2302,10 USD',
    link: 'https://umediadigital-my.sharepoint.com/:b:/g/personal/joselynv_u-mediadigital_com/ES3R8Ind7NlKv9IRzd6llNQBdzoCkAd1vgPytTHBJ0VT2w?e=iL7UxH',

    status: 'pending',
    statusType: 'warning',
    completion: 60
  },
  {
    //img: 'img/theme/bootstrap.jpg',
    title: 'PERITO X',
    budget: 'BGYE-2021-XXX',
    type: 'TIPO XXX',
    fullname: 'CLIENTE NOMBRE',
    city: 'CIUDAD',
    vrealizacion: '$0 USD',
    vmercado: '$0 USD',
    locationmap: '',
    oaccount: 'Asignado',
    vfactura: '$2302,10 USD',
    link: 'https://umediadigital-my.sharepoint.com/:b:/g/personal/joselynv_u-mediadigital_com/ES3R8Ind7NlKv9IRzd6llNQBdzoCkAd1vgPytTHBJ0VT2w?e=iL7UxH',

    status: 'pending',
    statusType: 'warning',
    completion: 60
  },
  {
    //img: 'img/theme/bootstrap.jpg',
    title: 'PERITO X',
    budget: 'BGYE-2021-XXX',
    type: 'TIPO XXX',
    fullname: 'CLIENTE NOMBRE',
    city: 'CIUDAD',
    vrealizacion: '$0 USD',
    vmercado: '$0 USD',
    locationmap: '',
    oaccount: 'Asignado',
    vfactura: '$2302,10 USD',
    link: 'https://umediadigital-my.sharepoint.com/:b:/g/personal/joselynv_u-mediadigital_com/ES3R8Ind7NlKv9IRzd6llNQBdzoCkAd1vgPytTHBJ0VT2w?e=iL7UxH',

    status: 'pending',
    statusType: 'warning',
    completion: 60
  },
  


]



//{
  //   img: 'img/theme/angular.jpg',
  //   title: 'Angular Now UI Kit PRO',
  //   budget: '$1800 USD',
  //   status: 'completed',
  //   statusType: 'success',
  //   completion: 100
  // },
  // {
  //   img: 'img/theme/sketch.jpg',
  //   title: 'Black Dashboard',
  //   budget: '$3150 USD',
  //   status: 'delayed',
  //   statusType: 'danger',
  //   completion: 72
  // },
  // {
  //   img: 'img/theme/react.jpg',
  //   title: 'React Material Dashboard',
  //   budget: '$4400 USD',
  //   status: 'on schedule',
  //   statusType: 'info',
  //   completion: 90
  // },
  // {
  //   img: 'img/theme/vue.jpg',
  //   title: 'Vue Paper UI Kit PRO',
  //   budget: '$2200 USD',
  //   status: 'completed',
  //   statusType: 'success',
  //   completion: 100
  // },
  // {
  //   img: 'img/theme/bootstrap.jpg',
  //   title: 'Argon Design System',
  //   budget: '$2500 USD',
  //   status: 'pending',
  //   statusType: 'warning',
  //   completion: 60
  // },
  // {
  //   img: 'img/theme/angular.jpg',
  //   title: 'Angular Now UI Kit PRO',
  //   budget: '$1800 USD',
  //   status: 'completed',
  //   statusType: 'success',
  //   completion: 100
  // },
  // {
  //   img: 'img/theme/sketch.jpg',
  //   title: 'Black Dashboard',
  //   budget: '$3150 USD',
  //   status: 'delayed',
  //   statusType: 'danger',
  //   completion: 72
  // },
  // {
  //   img: 'img/theme/vue.jpg',
  //   title: 'Vue Paper UI Kit PRO',
  //   budget: '$2200 USD',
  //   status: 'completed',
  //   statusType: 'success',
  //   completion: 100
  // }

